function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
  fill: "#F0F0F0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0-4.76-2.765-8.858-6.78-10.807v21.602A11.967 11.967 0 0024 12zM.011 12c0 4.76 2.764 8.858 6.78 10.807V1.193C2.775 3.142.01 7.24.01 12z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9,
  r: 0.8,
  stroke: "#6DA544",
  strokeWidth: 0.4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.246C8 14.314 9.796 16 12 16c2.204 0 4-1.686 4-3.754V11H8v1.246z",
  fill: "#6DA544"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10 9.556L10.5 9s.5.556 1 .556S12 9 12 9s0 .556.5.556 1-.556 1-.556l.5.556s-.5 1.11-.5 1.666c0 .556.5 1.111.5 1.667 0 .555-.5 1.111-2 1.111s-2-.556-2-1.111c0-.556.5-1.111.5-1.667 0-.555-.5-1.666-.5-1.666z",
  fill: "#D20F22",
  stroke: "#F0F0F0",
  strokeWidth: 0.5
});

function SvgFlagPe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "/img/flag_pe.svg";
export { SvgFlagPe as ReactComponent };